import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import { goAiEditPage, useAITools } from "@/utils/gdEdit";
import { useAiToolUrl } from "@/utils/hooks/useAiToolUrl";
import classNames from "classnames";
import PinDetailButton from "../Button";
import styles from "./index.module.less";

export function isHideAiTools(pin: IPin, isMaterial: boolean) {
  return isMaterial || pin?.domain?.copyright_domain || !pin?.file;
}
export default function NewPinDetailAiTools({
  pin,
  isMaterial,
  searchWord,
}: {
  pin: IPin;
  isMaterial: boolean;
  searchWord: string;
}) {
  const configList = useAITools();
  const shouldShowAiTools = !isHideAiTools(pin, isMaterial);
  const { aiToolUrl } = useAiToolUrl(shouldShowAiTools);

  if (!shouldShowAiTools) {
    return null;
  }

  return (
    <div
      data-content-source="AI工具推荐"
      className={styles.newAiTools}
      data-search-word={searchWord}
    >
      <div className={classNames(styles.list, styles.new)}>
        {configList.map((tool, index) => {
          return (
            <PinDetailButton
              key={index}
              data-gd-click="button_click"
              data-gd-expose="button_expose"
              data-button-name={tool.name}
              className={styles.btn}
              onClick={() => {
                if (index === configList.length - 1) {
                  // 最后一个按钮是更多，跳转到AI工具页
                  window.open(aiToolUrl, "_blank");
                } else {
                  goAiEditPage({
                    pin,
                    conf: tool,
                  });
                }
              }}
            >
              {tool.rightTag?.length > 0 && (
                <div className={styles.tag}>
                  <Image src={tool.rightTag[0].url} alt="tag" height={18} />
                </div>
              )}
              {index === configList.length - 1 ? (
                <Image
                  src="https://grocery-cdn.huaban.com/file/651a4b50501611f0a59ecb9f4a74cfb9.svg"
                  width={14}
                  height={14}
                  alt="更多工具"
                  className={styles.more}
                />
              ) : (
                <HBIcon type={tool.icon} />
              )}
              {index === configList.length - 1 ? "更多工具" : tool.name}
            </PinDetailButton>
          );
        })}
      </div>
      <div className={styles.agreement}>
        不得侵犯他人合法权益，详见
        <a
          href="https://huaban.com/about/disclaimer?activeKey=0"
          target="_blank"
        >
          《用户协议》
        </a>
        第十一条第二款
      </div>
    </div>
  );
}
